export const visit = (vm, at) => {
at({ "en": { "conversations-inbox-message-history": { "email-capture": { "emailCaptureResponseText": "Visitor submitted their email: <a href='mailto:{{email}}' target='_blank' rel='nofollow noopener noreferrer'>{{ email }}</a>" } } } });
};